import { httr } from "../../../httpsnippet-lite/esm/targets/r/httr/client.js";
import { convertWithHttpSnippetLite } from "../../../utils/convertWithHttpSnippetLite.js";
const rHttr = {
  target: "r",
  client: "httr",
  title: "httr",
  generate(request) {
    return convertWithHttpSnippetLite(httr, request);
  }
};
export {
  rHttr
};
//# sourceMappingURL=httr.js.map
